<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-card>
          Statistiques pour l'activité {{ activite.ll_parcours }}

          <div class="ma-4 pa-4">
            <div class="h4">
              {{ activite.abbr_bailleur }} - {{ activite.ll_bailleur }}
            </div>
            <div class="h4">
              {{ activite.ll_programme }} - {{ activite.ll_theme }}
            </div>
            <div class="h4">
              {{ activite.ll_parcours }} - {{ etape.ll_etape }}
            </div>
            <!--  <div>{{ $route.query.ll_details_etapes }}</div> -->
          </div>
          <v-card-actions>
            <v-container fluid>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-btn
                    class="blue mx-4"
                    dark
                    :loading="loadingMembre"
                    @click="getFichesCorrespondantes()"
                  >
                    Afficher les données</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
          <v-card-text>
            <div>Nombre: {{ fiches.length }}</div>
            <div v-if="$route.query.type_champ == 1">
              {{ $route.query.ll_details_etapes }} :
              <strong>{{ calcul.toLocaleString() }}</strong>
            </div>

            <vue-excel-xlsx
              class="mt-4"
              v-if="fiches.length > 0"
              :data="fiches"
              :columns="headers"
              :filename="'fiches' + Date.now()"
              :sheetname="'fiches'"
            >
              <v-btn class="green" dark>
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Télécharger les
                {{ fiches.length }} résultats</v-btn
              >
            </vue-excel-xlsx>

            <v-data-table
              dense
              :headers="headers"
              :items="fiches"
              locale="fr"
              :items-per-page="50"
            >
              <template v-slot:item.sexe="{ item }">
                {{ getSexe(item.sexe) }}
              </template>
              <template v-slot:item.date_fiche="{ item }">
                {{ epochToTimeStamp(item.date_fiche) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  data() {
    return {
      loadingMembre: false,
      etape: "",
      activite: "",
      fiches: [],
      headers: [
        {
          text: "Id",
          value: "membres_id_membre",
          label: "Id",
          field: "membres_id_membre",
        },
        {
          text: "Nom",
          label: "Nom",
          value: "nom",
          field: "nom",
        },
        {
          text: "Année de naissance",
          label: "Année de naissance",
          value: "annee_naissance",
          field: "annee_naissance",
        },
        {
          text: "Sexe",
          value: "sexe",
          label: "Sexe",
          field: "sexe",
          dataFormat: this.getSexe,
        },
        {
          text: "Groupe",
          label: "Groupe",
          value: "nom_groupe",
          field: "nom_groupe",
        },
        {
          text: this.$route.query.ll_details_etapes,
          label: this.$route.query.ll_details_etapes,
          value: "valInt",
          field: "valInt",
        },
        {
          text: "Date de saisie",
          label: "Date de saisie",
          value: "date_fiche",
          field: "date_fiche",
          dataFormat: this.epochToTimeStamp,
        },

        {
          text: "Animateur",
          label: "Animateur",
          value: "nom_responsable",
          field: "nom_responsable",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
        {
          text: "Village",
          value: "village",
          label: "Village",
          field: "village",
        },
      ],
    };
  },
  created() {
    this.getEtape(this.$route.query.etape_id_etape);
  },
  computed: {
    calcul: function () {
      /* Nombre
       var result = 0;
       for (var i = 0; i < $scope.traveler.length; i++) {
              total = total + $scope.traveler[i].Amount;
            } */
      if (this.$route.query.type_champ == 1) {
        return _.sumBy(this.fiches, function (o) {
          return o.valInt;
        });
      } else if (this.$route.query.type_champ == 2) {
        return 0;
      }
    },

    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      user: (state) => state.Auth.user,
      Activites: (state) => state.Activites.Activites,
      listeRegionsSupervisees: (state) => state.Utils.listeRegionsSupervisees,
    }),
  },
  methods: {
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    epochToTimeStamp(date) {
      return this.$moment(date).format("MM-YYYY");
    },
    getEtape(etapeId) {
      let self = this;
      var docRef = this.$firebase.firestore().collection("etapes").doc(etapeId);
      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.etape = doc.data();

            var docRef2 = self.$firebase
              .firestore()
              .collection("activites")
              .doc(self.etape.parcours_id_parcours);

            docRef2
              .get()
              .then((doc) => {
                if (doc.exists) {
                  self.activite = doc.data();
                } else {
                  // doc.data() will be undefined in this case
                  console.log("No such document!");
                }
              })
              .catch((error) => {
                console.log("Error getting document:", error);
              });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    getFichesCorrespondantes() {
      let self = this;
      self.fiches = [];
      self.loadingMembre = true;
      this.$firebase
        .firestore()
        .collection("fiches")
        .where("details_etapes_id_details_etape", "==", self.$route.query.id)
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              if (self.$route.query.type_champ == 1) {
                self.fiches.push({
                  ...doc.data(),
                  id: doc.id,
                  valInt: Number(doc.data().valeur),
                });
              } else if (self.$route.query.type_champ == 0) {
                if (doc.data().valeur) {
                  //console.log("valeur : ",doc.data().valeur)
                  self.fiches.push({
                    ...doc.data(),
                    id: doc.id,
                    valInt: doc.data().valeur,
                  });
                }
              } else {
                self.fiches.push({
                  ...doc.data(),
                  id: doc.id,
                  valInt: doc.data().valeur,
                });
              }
            });

            self.loadingMembre = false;
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>

<style scoped></style>
